export class Values {
    ParameterKind: Number;
    ParameterKindName: string;
    Key: string;
    Value: string;
    Position: Number;
    Module: Number;
    Type: Number;
    // DisplayValue: string;
    //DisplayValuePl: string;
    //DisplayValueEn: string;
    //DisplayValueDe: string;
    //DisplayValueFr: string;
    //DisplayValueCs: string;
    //DisplayValueIt: string;
    Disabled: boolean;
    File: any;
    FileName:string;
    Kolor:string;
    Index:string;
    GenDisplayValue: string;
 
  }
  